/**
 * The MIT License (MIT)
 * Copyright (c) 2017-present Dmitry Soshnikov <dmitry.soshnikov@gmail.com>
 */

'use strict';

/**
 * Epsilon, the empty string.
 */

var EPSILON = 'ε';

/**
 * Epsilon-closure.
 */
var EPSILON_CLOSURE = EPSILON + '*';

module.exports = {
  EPSILON: EPSILON,
  EPSILON_CLOSURE: EPSILON_CLOSURE
};


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/regexp-tree/dist/interpreter/finite-automaton/special-symbols.js
// module id = 104
// module chunks = 0